<script setup>
import { useMapGetter } from 'dashboard/composables/store';

const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <div
    class="flex flex-col bg-dot-pattern bg-dots-24 h-full w-full bg-neutral-50 dark:!bg-slate-900 dark:bg-dot-pattern-dark rounded-tl-[40px] rounded-bl-[40px]"
  >
    <div class="flex flex-col w-full h-full items-center justify-center gap-4">
      <div class="flex flex-col justify-start items-start gap-6">
        <!-- Clock -->
        <div class="flex flex-row gap-6 items-center">
          <svg
            class="w-10 h-10 min-[1440px]:w-14 min-[1440px]:h-14"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32.17"
            fill="none"
            preserveAspectRatio="xMidYMid meet"
          >
            <defs>
              <linearGradient id="iconGradientClock" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%">
                  <animate
                    attributeName="stop-color"
                    values="#BF36FF;#369EFF;#BF36FF"
                    dur="2s"
                    repeatCount="indefinite"
                  />
                </stop>
                <stop offset="100%">
                  <animate
                    attributeName="stop-color"
                    values="#369EFF;#BF36FF;#369EFF"
                    dur="2s"
                    repeatCount="indefinite"
                  />
                </stop>
              </linearGradient>
            </defs>

            <path
              fill="url(#iconGradientClock)"
              d="M16,30.67A14.59,14.59,0,1,1,30.58,16.09,14.6,14.6,0,0,1,16,30.67ZM16,4A12.09,12.09,0,1,0,28.08,16.09,12.1,12.1,0,0,0,16,4Z"
            />
            <path
              fill="url(#iconGradientClock)"
              d="M21,21.57a1.23,1.23,0,0,1-.64-.17l-4.14-2.47a4.19,4.19,0,0,1-1.91-3.36V10.1a1.25,1.25,0,0,1,2.5,0v5.47a1.73,1.73,0,0,0,.69,1.21l4.14,2.47A1.26,1.26,0,0,1,22,21,1.24,1.24,0,0,1,21,21.57Z"
            />
          </svg>

          <div class="text-[18px] min-[1440px]:text-[24px] text-[#1A1A1C] dark:text-white font-bold">
            پاسخگویی ۲۴ ساعته
          </div>
        </div>

        <!-- Calendar -->
        <div class="flex flex-row gap-6 items-center">
          <svg
            class="w-10 h-10 min-[1440px]:w-14 min-[1440px]:h-14"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32.17"
            fill="none"
            preserveAspectRatio="xMidYMid meet"
          >
            <defs>
              <linearGradient id="iconGradientCalendar" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%">
                  <animate
                    attributeName="stop-color"
                    values="#BF36FF;#369EFF;#BF36FF"
                    dur="2s"
                    repeatCount="indefinite"
                  />
                </stop>
                <stop offset="100%">
                  <animate
                    attributeName="stop-color"
                    values="#369EFF;#BF36FF;#369EFF"
                    dur="2s"
                    repeatCount="indefinite"
                  />
                </stop>
              </linearGradient>
            </defs>

            <path
              fill="url(#iconGradientCalendar)"
              d="M22.58,3.58V2.76a1.25,1.25,0,0,0-2.5,0v.75H11.91V2.76a1.25,1.25,0,0,0-2.5,0v.82C5.15,4,2.75,6.83,2.75,11.42V22.76c0,5,2.88,7.91,7.91,7.91H21.33c5,0,7.92-2.88,7.92-7.91V11.42C29.25,6.82,26.84,4,22.58,3.58ZM9.41,6.09v.67a1.25,1.25,0,1,0,2.5,0V6h8.17v.75a1.25,1.25,0,0,0,2.5,0V6.09c2.67.36,4,2,4.16,4.87H5.26C5.39,8.05,6.75,6.45,9.41,6.09ZM26.75,22.76c0,3.64-1.77,5.41-5.42,5.41H10.66c-3.64,0-5.41-1.77-5.41-5.41v-9.3h21.5Z"
            />
            <path
              fill="url(#iconGradientCalendar)"
              d="M16,19.6a1.25,1.25,0,0,1,0-2.5h0a1.25,1.25,0,0,1,0,2.5Z"
            />
            <path
              fill="url(#iconGradientCalendar)"
              d="M11.07,19.6a1.25,1.25,0,1,1,0-2.5h0a1.25,1.25,0,0,1,0,2.5Z"
            />
            <path
              fill="url(#iconGradientCalendar)"
              d="M11.07,23.6a1.25,1.25,0,1,1,0-2.5h0a1.25,1.25,0,0,1,0,2.5Z"
            />
          </svg>

          <div class="text-[18px] min-[1440px]:text-[24px] text-[#1A1A1C] dark:text-white font-bold">
            ۷ روز هفته
          </div>
        </div>

        <!-- AI -->
        <div class="flex flex-row gap-6 items-center">
          <svg
            class="w-10 h-10 min-[1440px]:w-14 min-[1440px]:h-14"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32.17"
            fill="none"
            preserveAspectRatio="xMidYMid meet"
          >
            <defs>
              <linearGradient id="iconGradientAI" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%">
                  <animate
                    attributeName="stop-color"
                    values="#BF36FF;#369EFF;#BF36FF"
                    dur="2s"
                    repeatCount="indefinite"
                  />
                </stop>
                <stop offset="100%">
                  <animate
                    attributeName="stop-color"
                    values="#369EFF;#BF36FF;#369EFF"
                    dur="2s"
                    repeatCount="indefinite"
                  />
                </stop>
              </linearGradient>
            </defs>

            <path
              fill="url(#iconGradientAI)"
              d="M21.73,22.67a1.25,1.25,0,0,1-1.25-1.25V14.35a1.25,1.25,0,1,1,2.5,0v7.07A1.25,1.25,0,0,1,21.73,22.67Z"
            />
            <path
              fill="url(#iconGradientAI)"
              d="M20,1.51H12C4.68,1.51,1.41,4.77,1.41,12.09v8c0,7.32,3.27,10.58,10.58,10.58h8c7.33,0,10.6-3.26,10.6-10.58v-8C30.59,4.77,27.32,1.51,20,1.51Zm8.1,18.58c0,6-2.12,8.08-8.1,8.08H12c-6,0-8.08-2.11-8.08-8.08v-8C3.91,6.12,6,4,12,4h8c6,0,8.1,2.11,8.1,8.08Z"
            />
            <path
              fill="url(#iconGradientAI)"
              d="M19.53,20.91l-4.8-10.67a1.22,1.22,0,0,0-1.13-.73,1.24,1.24,0,0,0-1.14.74L7.78,20.92a1.27,1.27,0,0,0,.65,1.65,1.31,1.31,0,0,0,.5.1,1.25,1.25,0,0,0,1.15-.75l1.25-2.85H16l1.29,2.87a1.25,1.25,0,0,0,2.27-1Zm-7.12-4.34,1.2-2.73,1.24,2.73Z"
            />
            <path
              fill="url(#iconGradientAI)"
              d="M21.78,12.05l-.24,0A1.13,1.13,0,0,1,21.3,12l-.21-.11a1.6,1.6,0,0,1-.19-.16,1.23,1.23,0,0,1-.37-.88.73.73,0,0,1,0-.25.86.86,0,0,1,.06-.23,2.26,2.26,0,0,1,.11-.22,1.46,1.46,0,0,1,.16-.19.7.7,0,0,1,.19-.15l.21-.12.24-.07a1,1,0,0,1,.49,0l.23.07.22.12a1.25,1.25,0,0,1,.19.15,1.39,1.39,0,0,1,.15.19,1.19,1.19,0,0,1,.12.22,1.55,1.55,0,0,1,.07.23,2.11,2.11,0,0,1,0,.25,1.27,1.27,0,0,1-.36.88l-.19.16-.22.11A1,1,0,0,1,22,12Z"
            />
          </svg>

          <div class="text-[18px] min-[1440px]:text-[24px] text-[#1A1A1C] dark:text-white font-bold">
            با قدرت هوش مصنوعی
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
